import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { FaArrowLeft, FaCalendarAlt, FaTag } from 'react-icons/fa';
import { getPostBySlug } from '../content/blog';
import './BlogPost.css';

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

const BlogPost = () => {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <section className="blog-post">
        <div className="container blog-post-missing">
          <h1>Post not found</h1>
          <p>That article does not exist or was moved.</p>
          <Link to="/blog" className="blog-back-link">
            <FaArrowLeft /> Back to blog
          </Link>
        </div>
      </section>
    );
  }

  return (
    <article className="blog-post">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          <Link to="/blog" className="blog-back-link">
            <FaArrowLeft /> Back to blog
          </Link>

          <header className="blog-post-header">
            <div className="blog-meta">
              <span className="blog-date">
                <FaCalendarAlt />
                {formatDate(post.date)}
              </span>
              {post.tags?.map((tag) => (
                <span key={tag} className="blog-tag">
                  <FaTag />
                  {tag}
                </span>
              ))}
            </div>
            <h1>{post.title}</h1>
            <p className="blog-post-excerpt">{post.excerpt}</p>
          </header>

          {post.cover && (
            <div className="blog-post-cover">
              <img src={post.cover} alt="" />
            </div>
          )}

          <div className="blog-post-content">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                img: ({ node, alt, src, ...props }) => (
                  <img
                    {...props}
                    src={src}
                    alt={alt || ''}
                    loading="lazy"
                    className="blog-inline-image"
                  />
                ),
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer" />
                )
              }}
            >
              {post.content.trim()}
            </ReactMarkdown>
          </div>
        </motion.div>
      </div>
    </article>
  );
};

export default BlogPost;
